/**
 * How a lot's length divides between orders and stock.
 *
 * The planned length answers two questions and only one is actionable: how much
 * is already somebody's, and how much is still free to promise. Two screens show
 * it now, and two screens computing "free" two different ways would eventually
 * disagree about the same product — so the rule lives here.
 *
 * The launch split is authoritative when the job has one. Allocations are the
 * fallback, for jobs launched before it existed.
 */

const num = v => (Number.isFinite(Number(v)) ? Number(v) : 0);

export function splitOf(job) {
  const launch = job?.source?.launch || {};
  const total = num(launch.lengthTotal) || num(job?.plannedLength);

  const allocated = (Array.isArray(job?.allocations) ? job.allocations : []).reduce(
    (s, a) => s + num(a?.allocatedMeters ?? a?.meters),
    0
  );

  const toOrders = Math.min(
    Math.max(0, total),
    Math.max(0, launch.lengthToOrders != null ? num(launch.lengthToOrders) : allocated)
  );

  return {
    total: Math.max(0, total),
    toOrders,
    toStock: Math.max(0, total - toOrders)
  };
}
